
import React from 'react';
import {
    BrowserRouter,
    Routes,
    Route,
} from "react-router-dom";
import Login from '../Pages/Login/login';
import {history} from './history';
import Register from '../Pages/UserPages/register';
import Profile from "../Pages/Tarbook/profile";
import Memberdetails from '../Pages/UserPages/memberdetails';
import QuestionBank from '../Pages/Tarbook/questionbank';
import TarbookInformation from '../Pages/Tarbook/tarbookinformation';
import Questionanswermeo from '../Pages/Tarbook/questionanswermeo';
import ResetPassword from '../Pages/Login/ResetPassword';
import ErrorPage from '../Pages/Login/ErrorPage';
import Admindashboard from '../Pages/Admin/admindashboard';
import Adminquestionbank from '../Pages/Admin/adminquestionbank';
import AdminMemberRegister from '../Pages/Admin/AdminMemberRegister';
import MemberList from '../Pages/Admin/MemberList';
import ChangePassword from '../Pages/Login/ChangePassword';
import SearchMembers from '../Pages/MemberPages/searchMembers';

class routerPage extends React.Component{
  constructor(props) {
    super(props);

    history.listen((location, action) => {});
  }
  
  render(){
    return(
      <div>
        <BrowserRouter history={history} >
          <Routes>
            {/* <PrivateRoute exact path="/" element={<Login/>} /> */}
            {/* <Route exact path="/login" element={<Login/>} /> */}
            {/* <Route exact path="/" element={<Login/>} />
            <Route path="/Profile" element={<Profile/>} />
            <Route path="/registration" element={<Register />} />
            <Route path='/memberportal' element={<Memberdetails />}/>
            <Route path='/questionbank' element={<QuestionBank />}/>
            <Route path='/tarbook' element={<TarbookInformation />} />
            <Route path='/questionsandanswersformeoexams' element={<Questionanswermeo />} />
            <Route path="/resetpassword" element={<ResetPassword />} />
            <Route path='/errorPage' element={<ErrorPage />} />
            <Route path='/admindashboard' element={<Admindashboard />} />
            <Route path='/adminquestionbank' element={<Adminquestionbank />} />
            <Route path='/memberregistration' element={<AdminMemberRegister />} />
            <Route path='/details' element={<MemberList />} />
            <Route path="/changepassword" element={<ChangePassword />} />
            <Route path='/searchMember' element={<SearchMembers />}/> */}
          </Routes >
        </BrowserRouter>
        <Admindashboard />
      </div>
    )
  }
}

export default routerPage;
